import request from '@/utils/request'

export function getAreaInfo(params) {
  return request({
    url: '/api/areaInfo/tree',
    method: 'get',
    params
  })
}

export function getDept(params) {
  return request({
    url: '/api/dept/smallList',
    method: 'get',
    params
  })
}

export function getDeptTree(params) {
  return request({
    url: '/api/dept/smallTree',
    method: 'get',
    params
  })
}


export function smallArea(params) {
  return request({
    url: 'api/dept/smallProduct',
    method: 'get',
    params
  })
}


export function getDepts(params) {
  return request({
    url: 'api/dept',
    method: 'get',
    params
  })
}

export function getMinioUrl(params) {
  return request({
    url: '/api/minio/getMinioUrl',
    method: 'get',
    params
  })
}



export function getSts(params) {
  return request({
    url: '/api/minio/getMinioSts',
    method: 'get',
    params
  })
}


export function getMallSts(params) {
  return request({
    url: '/api/minio/getMinioMallSts',
    method: 'get',
    params
  })
}

export function appversionLast(params) {
  return request({
    url: '/api/appVersion/last',
    method: 'get',
    params
  })
}

